<template>
    <b-btn
        v-if="dashboard?.pendingCreditCount"
        to="/creator/pendingCredit"
        class="bg-white"
        variant="light"
        block
        size="lg"
    >
        <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <div class="mr-2">
                    <font-awesome-icon
                        class="branded"
                        icon="fa-duotone fa-circle-dollar-to-slot"
                        size="lg"
                    />
                </div>
                Pending Credit
            </div>
            <div class="small">
                <coin-badge :amount="dashboard?.pendingCreditCount" />
            </div>
        </div>
    </b-btn>
</template>


<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
        ...mapState("creatorDashboard", ["dashboard"]),
    },
};
</script>
